// extracted by mini-css-extract-plugin
export default {"fadeInSection":"styles_fadeInSection__OPSxC","isVisible":"styles_isVisible__8--dt"};